<div class="pdf-buttons" *ngIf="userUID">
  <button
    mat-raised-button
    class="action-btn"
    (click)="pdfGenerator.printPdf(pdfContent)"
    [disabled]="userUID === undefined"
  >
    Print Diet Plan <img [src]="printIcon" />
  </button>
  <button
    mat-raised-button
    class="action-btn"
    (click)="pdfGenerator.downloadPdf(pdfContent, clientProfile?.firstName)"
    [disabled]="userUID === undefined"
  >
    Download Diet Plan <img [src]="downloadIcon" />
  </button>
  <button
    mat-raised-button
    class="action-btn"
    (click)="pdfGenerator.viewPdf(pdfContent)"
    [disabled]="userUID === undefined"
  >
    View Diet Plan <img [src]="eyeIcon" />
  </button>
</div>
<mat-card *ngIf="!isLoading">
  <label class="header-label">
    <mat-icon class="primary-color">supervisor_account</mat-icon>
    {{ clientProfile?.firstName }}'s Diet Plan <br />&nbsp;
    <span>BMI: {{ bmi }}</span> &nbsp; &nbsp;
    <span
      >Body Type:
      {{
        bmi! < 18.5
          ? "Underweight"
          : bmi! > 18.5 && bmi! < 24.9
          ? "Healthy"
          : bmi! > 25.0 && bmi! < 29.9
          ? "Overweight"
          : "Obese"
      }}</span
    >
  </label>
  <div class="meal-plan-selection">
    <form>
      <mat-form-field class="example-chip-list" appearance="outline">
        <mat-label>Select Meal Plan Time</mat-label>
        <mat-chip-grid #chipGrid aria-label="Meal Plan selection">
          <mat-chip-row
            *ngFor="let mealOpt of selectedMealOpt"
            (removed)="remove(mealOpt)"
          >
            {{ mealOpt.value }}
            <button matChipRemove [attr.aria-label]="'remove ' + mealOpt">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        </mat-chip-grid>
        <input
          placeholder="Meal plan options..."
          #fruitInput
          [formControl]="mealPlanContrl"
          [matChipInputFor]="chipGrid"
          [matAutocomplete]="auto"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="selected($event)"
        >
          <mat-option
            *ngFor="let mealOpt of filteredeMealOpt | async"
            [value]="mealOpt"
          >
            {{ mealOpt.value }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </div>
  <form [formGroup]="mealPlanForm">
    <ng-container formArrayName="mealPlans">
      <ng-container
        *ngFor="let mealPlan of isFormArray(mealPlans)?.controls; let i = index"
      >
        <div class="breakfast" [formGroupName]="i">
          <div>
            <mat-form-field
              appearance="outline"
              *ngIf="mealPlan.get('isLabelUpdated')?.value === true"
            >
              <input
                matInput
                type="text"
                placeholder="Enter meal time label"
                formControlName="mealPlanLabel"
              />
            </mat-form-field>
            <label *ngIf="mealPlan.get('isLabelUpdated')?.value === false">{{
              mealPlan.get("mealPlanLabel")?.value
            }}</label>
            <button
              mat-icon-button
              (click)="
                mealPlan
                  .get('isLabelUpdated')
                  ?.setValue(!mealPlan.get('isLabelUpdated')?.value)
              "
            >
              <mat-icon>{{
                mealPlan.get("isLabelUpdated")?.value ? "done" : "edit"
              }}</mat-icon>
            </button>
          </div>
          <ng-container formArrayName="mealPlanTime">
            <ng-container
              *ngFor="
                let mealTime of isFormArray(mealPlan.get('mealPlanTime'))
                  .controls;
                let j = index
              "
            >
              <div
                [formGroupName]="j"
                class="breakfast-form"
                [ngClass]="{
                  'child-form': mealTime.get('child')?.value === true
                }"
              >
                <app-time-picker
                  [label]="'Timing'"
                  [selectedTime]="mealTime.get('timing')?.value"
                  (time)="selectTime($event, i, j)"
                ></app-time-picker>
                <mat-form-field appearance="outline">
                  <mat-label>Food Items</mat-label>
                  <mat-select
                    #mySelect
                    required
                    formControlName="foodItems"
                    (blur)="onBlur()"
                    (focus)="onBlur()"
                    (ngModelChange)="onFoodItemChange($event, i, j)"
                  >
                    <input
                      class="input-search"
                      placeholder="search food items"
                      type="text"
                      (input)="onSearch($event)"
                    />
                    <mat-option
                      *ngFor="let item of filteredItems"
                      [value]="item.foodItem"
                      >{{ item.foodItem }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Quantity</mat-label>
                  <input matInput type="number" formControlName="quantity" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Unit</mat-label>
                  <mat-select required formControlName="unit">
                    <mat-option *ngFor="let unit of units" [value]="unit">{{
                      unit
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Choice</mat-label>
                  <mat-select required formControlName="choice">
                    <mat-option *ngFor="let c of choices" [value]="c">{{
                      c
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <div
                  [ngStyle]="{
                    'margin-bottom':
                      mealTime.get('child')?.value === false ? '0px' : '35px'
                  }"
                >
                  <button
                    class="remove-btn"
                    mat-icon-button
                    (click)="removeBreakFastForm(i, j)"
                  >
                    <mat-icon
                      >{{
                        mealTime.get("child")?.value === false
                          ? "delete_forever"
                          : "delete"
                      }}delete</mat-icon
                    >
                  </button>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-container formArrayName="medicalNotes">
      <ng-container
        *ngFor="
          let medical of isFormArray(medicalNotes)?.controls;
          let i = index
        "
      >
        <div class="form-section-2" [formGroupName]="i">
          <div *ngIf="i === 0">
            <label>Notes</label>
            <button
              class="secondary-btn"
              mat-raised-button
              matSuffix
              (click)="addNotes()"
            >
              <mat-icon>add</mat-icon> Add Notes
            </button>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Notes Date</mat-label>
              <input
                matInput
                [matDatepicker]="notesDate"
                formControlName="notesDate"
              />
              <mat-datepicker-toggle matIconSuffix [for]="notesDate">
                <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #notesDate></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input matInput formControlName="medicalCondition" />
            </mat-form-field>
            <button
              *ngIf="i !== 0"
              class="remove-btn"
              mat-icon-button
              (click)="removeNotes(i)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div class="form-section-3">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Medical History</mat-label>
          <input matInput type="text" formControlName="medicalHistory" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Diagnosis</mat-label>
          <input matInput type="text" formControlName="diagnosis" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Dietery Principles</mat-label>
          <mat-select formControlName="dieteryPrinciples" multiple>
            <mat-option
              *ngFor="let option of dieteryPrinciples"
              [value]="option.dietery"
              >{{ option.dietery }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Investigation Advised</mat-label>
          <mat-select formControlName="investigationAdvised" multiple>
            <mat-option
              *ngFor="let option of investigationData"
              [value]="option.investigation"
              >{{ option.investigation }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Supplement Advised</mat-label>
          <mat-select formControlName="suppementAdvised" multiple>
            <mat-option
              *ngFor="let option of supplementData"
              [value]="option.supplements"
              >{{ option.supplements }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Do's for Diet</mat-label>
          <mat-select formControlName="dietDo" multiple>
            <mat-option
              *ngFor="let option of dosDietData"
              [value]="option.dosDiet"
              >{{ option.dosDiet }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Don't for Diet</mat-label>
          <mat-select formControlName="dietDont" multiple>
            <mat-option
              *ngFor="let option of dontDietData"
              [value]="option.dontDiet"
              >{{ option.dontDiet }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Do's for Lifestyle</mat-label>
          <mat-select formControlName="lifestyleDo" multiple>
            <mat-option
              *ngFor="let option of dosLifestyleData"
              [value]="option.dosLifestyle"
              >{{ option.dosLifestyle }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Don't for Lifestyle </mat-label>
          <mat-select formControlName="lifestyleDont" multiple>
            <mat-option
              *ngFor="let option of dontLifestyleData"
              [value]="option.dontLifestyle"
              >{{ option.dontLifestyle }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <!-- <mat-form-field appearance="outline">
          <mat-label>More Tips </mat-label>
          <mat-select formControlName="nextCounsellingDesc" multiple>
            <mat-option
              *ngFor="let option of dontLifestyleData"
              [value]="option.dontLifestyle"
              >{{ option.dontLifestyle }}</mat-option
            >
          </mat-select>
        </mat-form-field> -->
        <mat-form-field appearance="outline">
          <mat-label>Select Next Counselling Date</mat-label>
          <input
            matInput
            [matDatepicker]="nextCounsellingDate"
            formControlName="nextCounsellingDate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="nextCounsellingDate">
            <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #nextCounsellingDate></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="btn-row">
      <button
        (click)="onSubmit('Saved')"
        mat-raised-button
        class="secondary-btn"
      >
        Save for Later <img [src]="saveIcon" />
      </button>
      <button
        (click)="onSubmit('Submitted')"
        mat-raised-button
        class="primary-btn"
      >
        Submit & View Diet Plan <img [src]="submitIcon" />
      </button>
    </div>
  </form>
</mat-card>
<div class="spinner" *ngIf="isLoading">
  <mat-spinner mode="indeterminate"></mat-spinner>
  <h2>{{ message }}</h2>
</div>
